<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaUserForm v-if="user" :user="user" />
      <LoadingPage v-if="!user"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaUserForm from '@/components/settings/arena/user/ArenaUserForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'ArenaUserEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaUserForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      user: state => state.arena.userById
    })
  },
  methods: {
    ...mapActions('arena', ['fetchArenaUserById'])
  },
  mounted () {
    this.fetchArenaUserById(this.$route.params.id)
  }
}
</script>
